import api from 'Common/Client/Interceptor';

export const selfLearnerService = {
  // Get available courses for self-learner
  getAvailableCourses: async (params = {}) => {
    try {
      // Prepare query parameters with defaults. Spread the caller's params first
      // so extra filters (e.g. excludeEnrolled, search) are forwarded, then apply defaults.
      const queryParams = {
        ...params,
        PageNumber: params.PageNumber || 1,
        PageSize: params.PageSize || 9,
        OrderByLatest: params.OrderByLatest !== undefined ? params.OrderByLatest : true,
        isPublished: params.isPublished !== undefined ? params.isPublished : true // Default to published for learners
      };

      // Remove undefined values
      Object.keys(queryParams).forEach(key => {
        if (queryParams[key] === undefined) {
          delete queryParams[key];
        }
      });

      console.log(" Fetching available courses with params:", queryParams);

      const response = await api.get('/indv/Course/Learner/Available-Courses', {
        params: queryParams
      });

      console.log(" Available courses data received:", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching available courses:', error);
      throw error;
    }
  },

  // Get course details with modules
  getCourseDetails: async (courseId) => {
    try {console.log("fetkhfdask fklas dfcourse detail...........; jfklasjdf");
      const response = await api.get(`/indv/Course/Learner/Get-With-Detail/${courseId}`);
                                      
console.log("course detail...........; jfklasjdf?????????????????????????????",response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching course details:', error);
      throw error;
    }
  },

 // In selfLearnerService
purchaseExpertSupport: async (payload) => {
  try {
    // Add the return URL to the payload
    const returnUrl = `${window.location.origin}/payment-success`;
    const cancelUrl = `${window.location.origin}/payment-canceled`;
    
    const response = await api.post('/indv/ExpertServicePurchase/Enrollment/Request', {
      ...payload,
      returnUrl,
      cancelUrl
    });
    
    return response.data;
  } catch (error) {
    console.error('Error purchasing expert support:', error);
    throw error;
  }
},



  // Enroll in a course
  enrollInCourse: async (courseId) => {
    try {
      const response = await api.post('/indv/CourseEnrollment/Create', {
        courseId: courseId
      });
      return response.data;
    } catch (error) {
      console.error('Error enrolling in course:', error);
      throw error;
    }
  },
  // enrollment for purchased course

  requestCoursePurchase: async (courseId, addOnExpertSupport) => {

    try {
      const res = await api.post("/indv/CoursePurchase/Request", {
        courseId,
        addOnExpertSupport
      });
      return res.data;
    }
    catch (error) {
      throw error;
    }

  },



  // Get enrolled courses with pagination
  getEnrolledCourses: async ({
    pageNumber = 1,
    pageSize = 6,
    orderByLatest = true,
    isCompleted
  } = {}) => {
    try {
      const params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        OrderByLatest: orderByLatest
      };
      if (isCompleted !== undefined) params.isCompleted = isCompleted;

      const response = await api.get('/indv/CourseEnrollment/Get-List', { params });
      console.log("enrolled courses///////////////////,", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching enrolled courses:', error);
      throw error;
    }
  },


  // continue learning
  startCourseEnrollment: async (enrollmentId) => {
    try {
      const response = await api.get(`/indv/CourseEnrollment/Start/${enrollmentId}`);
      return response.data;
    } catch (error) {
      console.error('Error starting course enrollment:', error);
      throw error;
    }
  },

  getEnrolledCourseDetails: async (enrollmentId) => {
    try {
      const response = await api.get(`/indv/CourseEnrollment/Learner/Get-With-Detail/${enrollmentId}`);
      console.log("..............???...", response.data);

      return response.data;
    } catch (error) {
      console.error('Error fetching enrolled course details:', error);
      throw error;
    }
  },



  // Get module progress details with pages
  getModuleProgressDetails: async (moduleProgressId) => {
    try {
      // Check what ID you're passing
      console.log(' moduleProgressId being passed:', moduleProgressId);
      const response = await api.get(`/indv/CourseModuleProgress/Get-With-Detail/${moduleProgressId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching module progress details:', error);
      throw error;
    }
  },


  // Get page file for learner -
  getLearnerPageFile: async (pageFileId) => {
    try {
      const response = await api.get(`/indv/CourseModule/page-file/${pageFileId}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching page file:', error);
      throw error;
    }
  },


  // Get page file for learner -
  getLearnerPageData: async (moduleId, pageId, isAssessment = false) => {
    try {
      const params = {
        moduleId: moduleId
      };

      if (isAssessment) {
        params.isAssessment = true;
      } else if (pageId) {
        params.pageId = pageId;
      }

      const response = await api.get(`/indv/CourseModuleProgress/Get-Page`, {
        params: params
      });

      console.log("........... learner page data", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching learner page data:', error);
      throw error;
    }
  },






  getAssessmentById: async (assessmentId) => {
    try {
      const response = await api.get(`/indv/Assessment/Get-Single/${assessmentId}`);
      console.log("............... assess id", assessmentId);
      console.log("............... assessmnt data ", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching assessment:', error);
      throw error;
    }
  },

  // Submit assessment result
  submitAssessmentResult: async (submissionData) => {
    try {
      const response = await api.post('/indv/AssessmentResult/Submit', submissionData);
      return response.data;
    } catch (error) {
      console.error('Error submitting assessment:', error);
      throw error;
    }
  },


};





